
import type { BaseErrorResponse, OtpCheckReq, OtpCheckRes, OtpEmailReq, OtpRes, OtpSmsReq } from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useOtp() {
  class Otp<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags OTP
     * @name OtpControllerOtpEmail
     * @summary Sending a one-time password to email
     * @request POST:/api3/otp/email
     * @response `200` `OtpRes`
     * @response `400` `BaseErrorResponse`
     */
    otpControllerOtpEmail = (data: OtpEmailReq, params: RequestParams = {}) =>
      this.request<OtpRes, BaseErrorResponse>({
        path: '/api3/otp/email',
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags OTP
     * @name OtpControllerOtpSms
     * @summary Sending a one-time password via sms
     * @request POST:/api3/otp/sms
     * @response `200` `OtpRes`
     * @response `400` `BaseErrorResponse`
     */
    otpControllerOtpSms = (data: OtpSmsReq, params: RequestParams = {}) =>
      this.request<OtpRes, BaseErrorResponse>({
        path: '/api3/otp/sms',
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags OTP
     * @name OtpControllerOtpCheck
     * @summary Checking a one-time password
     * @request POST:/api3/otp/check
     * @response `200` `OtpCheckRes`
     * @response `400` `BaseErrorResponse`
     */
    otpControllerOtpCheck = (data: OtpCheckReq, params: RequestParams = {}) =>
      this.request<OtpCheckRes, BaseErrorResponse>({
        path: '/api3/otp/check',
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Otp();
}
